import { useState, useEffect, useCallback } from "react";
import { HandySvg } from "handy-svg";
import { Link } from "react-router-dom";
import iconCross from "../../assets/icons/svg-sprite/close-cross--small.svg";
import iconAttention from "../../assets/icons/svg-sprite/attention.svg";
import iconPointerLeft from "../../assets/icons/svg-sprite/point-arrow-left.svg";
import { cards } from "../../lib/api/api";
import closeBanner from "../../modules/close-banner";

const PaymentList = ({ message }) => {
  const [ID, setID] = useState(0);
  const [list, setList] = useState({ info: [], loading: false });
  const [limit, setLimit] = useState(5);

  useEffect(() => {
    closeBanner();
    cards
      .userCard()
      .then((res) => {
        setID(res[0].id);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (ID !== 0) {
      cards
        .payments(ID)
        .then((res) => {
          setList({ info: res, loading: true });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [ID]);

  const loadMoreData = useCallback(() => {
    setLimit((prevState) => prevState + 5);
    const btn = document.getElementById("partner-hide-more-payments");
    btn.style.removeProperty("display");
  }, []);

  const hideData = useCallback((event) => {
    setLimit(5);
    event.target.style.display = "none";
  }, []);

  function changeOfDate(date) {
    return `${date.slice(8, 10)}.${date.slice(5, 7)}.${date.slice(0, 4)}`;
  }

  return (
    <>
      {!list.loading && <div className="preloader__wrapper" />}
      <div
        className="cart"
        style={
          list.loading ? {} : { overflow: "hidden", height: "0px", margin: 0 }
        }
      >
        <div className="cart__inner page-container">
          <div className="page-container">
            <div className="cart__header">
              <div className="cart__header-inner">
                <Link className="cart__return" to="/">
                  <HandySvg
                    className="svg-icon cart__return-icon"
                    src={iconPointerLeft}
                    width="18"
                    height="10"
                  />
                  <span className="cart__return-text">Вернуться назад</span>
                </Link>
                <h1 className="cart__title title title--h2">
                  История платежей
                </h1>
              </div>
              <div
                className="partner-wallet-history__description"
                style={{ marginTop: 60 }}
              >
                <p>История платежей</p>
              </div>
            </div>
            <div className="partner-wallet-history__table operations-table">
              <ul className="operations-table__list">
                <li className="operations-table__item operations-table__heading-line">
                  <div className="operations-table__intro">
                    <span className="operations-table__heading">Дата</span>
                  </div>
                  <div className="operations-table__main">
                    <ul className="operations-table__group">
                      <li className="operations-table__card operations-table__heading">
                        Дата зачисления
                      </li>
                      <li className="operations-table__type operations-table__heading">
                        Детализация
                      </li>
                      <li className="operations-table__sum operations-table__heading">
                        Сумма
                      </li>
                    </ul>
                  </div>
                </li>
                {list.info.map((item, index) =>
                  index < limit ? (
                    <li className="partner-card-history-line operations-table__item">
                      <div className="operations-table__intro">
                        <div className="operations-table__date">
                          {changeOfDate(item.date_payment)}
                        </div>
                      </div>
                      <div className="operations-table__main">
                        <ul className="operations-table__group">
                          <li className="operations-table__card">
                            <span>{changeOfDate(item.date_balance)}</span>
                          </li>
                          <li className="operations-table__type">
                            <span>{item.method}</span>
                          </li>
                          <li className="operations-table__sum">
                            <span>{item.summa}</span>
                          </li>
                        </ul>
                      </div>
                    </li>
                  ) : (
                    ""
                  )
                )}
              </ul>
              <button
                className="ghost-btn ghost-btn--md ghost-btn--blue bttn"
                onClick={loadMoreData}
                type="button"
                style={{ marginTop: 30 }}
              >
                Показать еще платежи
              </button>
              <button
                id="partner-hide-more-payments"
                className="arrow-link arrow-link--blue"
                onClick={hideData}
                type="button"
                style={{
                  marginTop: 33,
                  marginLeft: 30,
                  display: "none",
                  background: "none",
                }}
              >
                Скрыть платежи
              </button>
            </div>
            <div
              id="messageBanner"
              className="info-cards__message-container js-closing-banner is-active"
              style={{ display: "none" }}
            >
              <div className="info-cards__message">
                <div className="info-cards__message-content">
                  <HandySvg
                    className="svg-icon"
                    src={iconAttention}
                    width="36"
                    height="36"
                  />
                  <div className="info-cards__message-text">{message}</div>
                </div>
                <button
                  className="js-close-btn info-cards__message-btn"
                  type="button"
                >
                  <HandySvg
                    className="svg-icon"
                    src={iconCross}
                    width="13"
                    height="12"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentList;
